var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_455_331",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 18
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.567383,
    width: 16.8649,
    height: 16.8649,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_455_331)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.46756 14.6212C6.89819 14.6212 5.56306 14.0766 4.46216 12.9874C3.36126 11.8982 2.81081 10.5689 2.81081 8.99955V8.87658L1.68648 10.0009L0.702698 9.01712L3.51351 6.20631L6.32432 9.01712L5.34054 10.0009L4.21621 8.87658V8.99955C4.21621 10.1707 4.62905 11.1662 5.45473 11.986C6.2804 12.8059 7.28468 13.2158 8.46756 13.2158C8.77207 13.2158 9.07072 13.1806 9.36351 13.1104C9.6563 13.0401 9.94324 12.9347 10.2243 12.7941L11.2784 13.8482C10.8333 14.1059 10.3766 14.2991 9.9081 14.4279C9.43964 14.5568 8.95946 14.6212 8.46756 14.6212ZM13.3513 11.7928L10.5405 8.98198L11.5243 7.9982L12.6486 9.12253V8.99955C12.6486 7.82838 12.2358 6.83289 11.4101 6.01307C10.5845 5.19325 9.58018 4.78334 8.39729 4.78334C8.09279 4.78334 7.79414 4.81847 7.50135 4.88874C7.20855 4.95901 6.92162 5.06442 6.64054 5.20496L5.58648 4.1509C6.03153 3.89325 6.48828 3.7 6.95675 3.57117C7.42522 3.44234 7.9054 3.37793 8.39729 3.37793C9.96666 3.37793 11.3018 3.92252 12.4027 5.01171C13.5036 6.1009 14.0541 7.43018 14.0541 8.99955V9.12253L15.1784 7.9982L16.1622 8.98198L13.3513 11.7928Z",
    fill: "#1C74D0"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.706ee0b2b10d655306c68313323baa6e.svg";
export { ForwardRef as ReactComponent };